define('SageDotCom/DataLayer/Util/trackingHelper',['jquery'], function ($) {

    function trackingHelper() { }

    // appends the value of 'tracking' as data-tracking to the component
    trackingHelper.prototype.registerTracking = function registerTracking(component, tracking) {
        var delim = '|';
        var existing = $(component).attr('data-tracking') || '';

        // if we are registering multiple tracking types, we register them with the delim as a seperator
        // we also want to prevent the same registration from appearing multiple times, so we just return
        // if it's already registered

        if (existing.toLowerCase().indexOf(tracking.toLowerCase()) !== -1) {
            return;
        } else {
            var types = (existing.trim() !== '') ? existing.split(delim) : [];
            types.push(tracking);
            $(component).attr('data-tracking', types.join(delim));
            return;
        }
    };

    return new trackingHelper();
});
